var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9 12.5379H11.0479V18.8462H13.504V12.5331H15.8363V10.0672H13.5056C13.5056 9.87798 13.5033 9.69076 13.5009 9.50502C13.4958 9.09053 13.4907 8.68341 13.5119 8.27779C13.5452 7.64117 13.8522 7.34917 14.4618 7.31997C14.7474 7.3062 15.0335 7.30374 15.3195 7.30127C15.4597 7.30007 15.6 7.29886 15.7401 7.29632C15.7852 7.29544 15.8301 7.29191 15.8738 7.28847C15.8904 7.28716 15.9069 7.28586 15.9231 7.28473V5.00059C15.7468 5.00059 15.5716 5.00044 15.3972 5.00029C14.9424 4.99991 14.493 4.99953 14.0437 5.00179C13.9022 5.00276 13.76 5.01652 13.6192 5.03293C12.1756 5.20137 11.1922 6.22266 11.0832 7.71839C11.0475 8.20789 11.0471 8.70004 11.0466 9.19213C11.0463 9.41256 11.0461 9.63299 11.0427 9.85316C11.0419 9.90104 11.0421 9.94881 11.0423 10.0014C11.0424 10.0262 11.0425 10.0521 11.0425 10.0795H9V12.5379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.f7942927351a980b587f9743f187e1db.svg";
export { ForwardRef as ReactComponent };